import styled from "styled-components";
//components
import Text from "components/Text";
import { Button } from "components/Button";
import { Column, Row } from "components/Layout/Grid";

export const FinancialPendingMatterModalContainer = styled.div`
  background-color: #FFFFFF;
  padding: 16px 32px;
  border: none;
`;

export const FinancialPendingMatterModalRow = styled(Row)`
  margin-bottom: 16px;
  border-bottom: 1px solid #BEBEBE;
`

export const FinancialPendingMatterModalColumn = styled(Column)`
  align-items: flex-end;
  margin-bottom: 16px;
`

export const FinancialPendingMatterModalTitle = styled(Text)`
  text-transform: uppercase;
  font-weight: 700;
  margin-bottom: 17.5px;
`

export const FinancialPendingMatterModalText = styled(Text)`
  font-size: 12px;
  font-weight: 400;

  color: #858585;
`

export const FinancialPendingMatterModalValue = styled(Text)`
  font-weight: 900;

  margin-top: 8px;
`

export const FinancialPendingMatterCloseButtonRow = styled(Row)`
  display: flex;
  justify-content: center;

  margin-top: 24px;
`

export const FinancialPendingMatterCloseButton = styled(Button)`
  background-color: #0E4C54;
`

export const TitleListContainer = styled.div`
  width: 100%;
  min-height: 115px;
  max-height: 300px;
  padding: 16px 24px 16px 32px;
  overflow-y: auto;
  background-color: #F2F2F2;
  border-radius: 4px;

  & > div {
    border-bottom: 1px solid #BEBEBE;

    &:nth-child(n+1){
      padding: 32px 0;
    }

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }
  }
  `